import { render, staticRenderFns } from "./BenefitCategoryForm.vue?vue&type=template&id=fef46b62"
import script from "./BenefitCategoryForm.vue?vue&type=script&lang=js"
export * from "./BenefitCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports